export const StatedBeanClass = Symbol('stated-bean-class');

export const StatedBeanWrapper = Symbol('stated-bean-wrapper');

export const ForceUpdate = Symbol('stated-bean-force-update');
